<div class="main-container lg-view">
	<ng-container *ngIf="followUp.jobDetails">
		<h3>{{ followUp.jobDetails.jobName }}</h3>
		<h5 *ngIf="followUp.jobDetails.projectName">{{ followUp.jobDetails.projectName }}</h5>

		<ng-container
			*ngTemplateOutlet="followUp.jobDetails.siteAddress ? infoTemplate : null; context: { label: 'Address', text: followUp.jobDetails.siteAddress }">
		</ng-container>
		<ng-container
			*ngTemplateOutlet="followUp.jobDetails.serviceProvider ? infoTemplate : null; context: { label: 'Provider', text: followUp.jobDetails.serviceProvider }">
		</ng-container>
		<ng-container
			*ngTemplateOutlet="infoTemplate; context: { label: 'Job Status', text: followUp.jobDetails.status }">
		</ng-container>
		<ng-container *ngTemplateOutlet="infoTemplate; context: { label: 'Job ETA', text: followUp.jobDetails.jobEta }">
		</ng-container>
	</ng-container>

	<ng-container
		*ngTemplateOutlet="infoTemplate; context: { label: 'Follow-up Date', text: moment(followUp.dueDate).format('MM/DD/YYYY') }">
	</ng-container>

	<ng-container
		*ngTemplateOutlet="infoTemplate; context: { label: 'Follow-up Status', text: followUp.isClosed ? 'Closed' : 'Open' }">
	</ng-container>

	<app-loader *ngIf="followUp.jobFollowUpTypeId && !followUpTypesMap.size" [isInline]="true" class="inline">
	</app-loader>

	<ng-container *ngTemplateOutlet="infoTemplate; context: { label: 'Description', text: followUp.description }">
	</ng-container>
</div>

<div class="actions-container md-view">
	<ng-container *ngIf="!followUp.isClosed">
		<action-button [clickAction]="modal.open.bind(modal)" [icon]="ButtonIcons.Submit" [name]="'Mark Complete'"
			[disabled]="followUp.isClosed"></action-button>
		<action-button [clickAction]="navigateWithData.bind(self, 'edit')" [icon]="ButtonIcons.Comment" [name]="'Edit'"
			[disabled]="followUp.isClosed">
		</action-button>
	</ng-container>
</div>

<ng-template #infoTemplate let-label="label" let-text="text">
	<div class="details">
		<div class="details-text">
			<span class="label">{{ label }}</span>
			<span>{{ text }}</span>
		</div>
	</div>
</ng-template>

<generic-modal #modal>
	<ng-template #modalBody>Are you sure you want to complete this follow-up?</ng-template>
	<ng-template #modalActions>
		<button mat-button (click)="closeFollowUp(); modal.hide()">Yes</button>
		<button mat-button (click)="modal.hide()">No</button>
	</ng-template>
</generic-modal>